import { computed } from 'vue'

import { useRoute } from '#imports'

export const useSelectedFacetFiltersFromQuery = () => {
  const route = useRoute()

  const selectedFacetFiltersFromQuery = computed(() => ({
    categories: [route.query.category || []].flat() as string[],
    locations: [route.query.location || []].flat() as string[],
    experiences: [route.query.experience || []].flat() as string[],
    locationOptions: [route.query.locationOption || []].flat() as string[],
  }))

  return {
    selectedFacetFiltersFromQuery,
  }
}
